import $ from 'jquery'
import { alert_error, alert_message, post_json, get_myinfo,
         clear_myinfo, has_user_loggedin } from './common'

$(init)

async function init () {
  try {
    await update_login_status()
    $('#login-btn').on('click', async ($evt) => {
      $evt.preventDefault()
      $(document).trigger('x-show-login-modal')
    })
    $('#signup-btn').on('click', async ($evt) => {
      $evt.preventDefault()
      $(document).trigger('x-show-register-modal')
    })
    $('#logout-btn').on('click', async ($evt) => {
        $evt.preventDefault()
        try {
          await post_json('/users/logout')
          alert_message('Signed Out', "You've signed out successfully")
          clear_myinfo()
          await update_login_status()
        } catch (err) {
          alert_error(err)
        }
      })
  } catch (err) {
    alert_error(err)
  }
}

async function update_login_status () {
  let myinfo = await get_myinfo()
  let loggedin = has_user_loggedin(myinfo)
  if (myinfo && myinfo.inbox_unread_count > 0) {
    $('#main-inbox-link .unread-count')
      .text(myinfo.inbox_unread_count+'')
      .removeClass('d-none')
  } else {
    $('#main-inbox-link .unread-count').addClass('d-none')
  }
  $('body')
    .removeClass('unknown-state')
    .toggleClass('user-loggedin', loggedin)
    .toggleClass('user-not-loggedin', !loggedin)
  $(document).trigger('x-login-state-updated')
  if (loggedin) {
    $('#header-display-user-email').text(myinfo.email)
  }
}

